"use client";

import posthog from "posthog-js";
import { PostHogProvider as BasePostHogProvider } from "posthog-js/react";
import { useEffect, useRef, type ReactNode } from "react";

interface AnalyticsProviderProps {
  children: ReactNode;
  apiKey?: string;
  apiHost?: string;
}

export function AnalyticsProvider({
  children,
  apiKey,
  apiHost,
}: AnalyticsProviderProps) {
  const key = apiKey ?? process.env.NEXT_PUBLIC_POSTHOG_KEY;
  const host = apiHost ?? process.env.NEXT_PUBLIC_POSTHOG_HOST ?? "/ingest";
  const initialized = useRef(false);

  useEffect(() => {
    if (!key || initialized.current) return;
    posthog.init(key, {
      api_host: host,
      person_profiles: "identified_only",
      capture_pageview: false,
      capture_pageleave: true,
    });
    initialized.current = true;
  }, [key, host]);

  if (!key) return <>{children}</>;

  return <BasePostHogProvider client={posthog}>{children}</BasePostHogProvider>;
}
